import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const PartnersSectionLight = () => {
  const partners = [
    {
      name: 'Payability',
      logo: '/payability-logo.jpg',
      description: 'Next-day access to your marketplace earnings instead of waiting out Amazon\'s payout cycle. Up to 80% advanced daily, the balance on Amazon\'s normal schedule.',
      link: 'https://5jazx.share.hsforms.com/2WNPcmNYSQdCO12CmAN3maA',
      cta: 'Learn More'
    }
  ];

  return (
    <section className="py-16 bg-white" data-testid="partners-section">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-display text-slate-800 text-2xl sm:text-3xl">
            Our Partners
          </h2>
          <p className="text-slate-500 mt-2">
            Trusted solutions to help your Amazon business thrive
          </p>
        </motion.div>

        {/* Partners */}
        <div className="max-w-2xl mx-auto">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl border border-slate-200 p-8 transition-all duration-300 hover:shadow-lg hover:border-purple-200"
            >
              <div className="flex flex-col md:flex-row items-center gap-6">
                {/* Logo */}
                <div className="flex-shrink-0">
                  <div className="bg-white rounded-xl p-4 border border-slate-100">
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="h-12 w-auto"
                      data-testid={`partner-logo-${partner.name.toLowerCase()}`}
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-xl font-display text-slate-800 mb-2">{partner.name}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed mb-4">
                    {partner.description}
                  </p>
                  <a
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 font-medium transition-colors"
                    data-testid={`partner-cta-${partner.name.toLowerCase()}`}
                  >
                    {partner.cta}
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSectionLight;
